import React from 'react';
import type {
  PlaceAutocompleteOwnOptions,
  UsePlaceAutocompleteReturn,
} from './usePlaceAutocomplete';
import usePlaceAutocomplete from './usePlaceAutocomplete';

export interface PlaceAutocompleteRenderProps extends PlaceAutocompleteOwnOptions {
  children: (props: UsePlaceAutocompleteReturn) => React.ReactElement;
}

const PlaceAutocompleteRender = React.forwardRef<HTMLInputElement, PlaceAutocompleteRenderProps>(
  function PlaceAutocompleteRender({ children, ...props }, ref) {
    const result = usePlaceAutocomplete({ ref, ...props });

    return children(result);
  },
);

export default PlaceAutocompleteRender;
